import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as _  from 'lodash';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class DashboardService {
    url: any = environment.API_URL;
    header = {};

    constructor(
        private http: HttpClient
    ) { }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        console.log(json ,"xl")
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
            console.log('worksheet',worksheet);
            const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            console.log(workbook,"wb")
            const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            console.log(workbook,"excelbuffer")
    
            
            this.saveAsExcelFile(excelBuffer, excelFileName);
          }
        
          private saveAsExcelFile(buffer: any, fileName: string): void {
            const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
          }

          public exportAsCsvFile(json: any[], csvFileName: string): void {
            if (!json || json.length === 0) {
              console.error('No data provided for CSV export.');
              return;
            }
            const header = Object.keys(json[0]);
            const replacer = (key, value) => value === null ? '' : value; // Handles null values
            let csv = json.map(row => 
              header.map(fieldName => 
                JSON.stringify(row[fieldName], replacer)
              ).join(',')
            );
            csv.unshift(header.join(','));
            let csvArray = csv.join('\r\n');
        
            var blob = new Blob(["\uFEFF" + csvArray], {type: 'text/csv;charset=utf-8;' }); // Added BOM for Excel compatibility
            FileSaver.saveAs(blob, csvFileName + '_export_' + new Date().getTime() + '.csv');
          }


    getDashboard(data:any){
        return this.http.post(this.url + "appList/getDashboardAnalytics", data );
    }

    getDashboardCount(data:any){
        return this.http.get(this.url + "api/admin/dashboard-count", data );
    }


    getDownloadAppList(){
        return this.http.get(this.url + "appList/getTotalAppsDownloaded");
    }


    getActiveUsers(){
        return this.http.get(this.url + "appList/getHospitalsUsers");
    }


    // getActiveUsers()

    getTotalForms(){
        return this.http.get(this.url + "appList/getTotalForms");
    }

    getAgeGroup(data){
        return this.http.post(this.url + "appList/getAgeGroup", data);
    }

    deviceCount(){
        return this.http.get(this.url + "appList/getDeviceCountByHospital");
    }

    getDeviceModel(id:any){
        return this.http.post(this.url + "appList/getDeviceListsByHospital", id);
    }
    
    getManageBandsList(data){
        return this.http.get(this.url + "api/user/bands-list",data)
    }

}